import { useQuery } from '@tanstack/react-query';
import { fetchEquipmentTypes } from '../data-provider/shipment-equipment-type';

export const useGetEquipmentTypes = () => {
  return useQuery({
    queryKey: ['shipment-equipment-types-list'],
    queryFn: () => fetchEquipmentTypes(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
